import React from "react";
import Paper from "@material-ui/core/Paper";
import styled from "styled-components";
import { breakpoints, color, spacingDefaults } from "style/constants";

export const StyledPaper = styled(({ ...otherProps }) => <Paper {...otherProps} />)`
  && {
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid ${color.GRAY};
    margin-top: 80px;
    width: 100%;
    position: fixed;
    z-index: 1101;
  }
`;

export const StyledForm = styled.form`
  && {
    align-items: center;
    display: flex;
    max-width: ${breakpoints.xl}px;
    margin: auto;

    @media (max-width: ${breakpoints.xl}px) {
      padding-left: ${spacingDefaults.xxlarge};
    }
  }
`;
